import {
  AzureDevopsLogo,
  BitbucketLogo,
  GithubDarkLogo,
  GithubLogo,
  GitlabLogo,
  GoogleLogo,
  SlackLogo,
} from '@/components/illustrations';

export const OAuthProviders = {
  google: {
    logo: { light: GoogleLogo, dark: GoogleLogo },
    authIdentity: 'google',
    title: 'google',
    isLogin: true,
  },
  github: {
    logo: { light: GithubLogo, dark: GithubDarkLogo },
    authIdentity: 'github',
    title: 'github',
    isLogin: true,
  },
  slack: {
    logo: { light: SlackLogo, dark: SlackLogo },
    authIdentity: 'slack',
    title: 'slack',
    isLogin: true,
  },
  bitbucket: {
    logo: { light: BitbucketLogo, dark: BitbucketLogo },
    authIdentity: 'bitbucket',
    title: 'bitbucket',
    isLogin: true,
  },
  gitlab: {
    logo: { light: GitlabLogo, dark: GitlabLogo },
    authIdentity: 'gitlab',
    title: 'gitlab',
    isLogin: true,
  },
  azure_devops: {
    authIdentity: 'azure',
    title: 'azure',
    isLogin: true,
    logo: { light: AzureDevopsLogo, dark: AzureDevopsLogo },
  },
};
